import { useHandler } from "@redotech/react-util/hook";
import { FinalSaleReturnState } from "@redotech/redo-return-ui/flows/return-flow/final-sale";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FinalSaleReturnDetails = memo(function FinalSaleReturnDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<FinalSaleReturnState>) {
  const nextStepChange = useHandler((next: string | undefined) => {
    setState((state) => ({ ...state, next }));
  });

  return (
    <>
      <Text fontSize="xs" textColor="secondary">
        Next step
      </Text>
      {!state.next && (
        <Text fontSize="xs" fontWeight="regular" textColor="error">
          Required
        </Text>
      )}
      {stepSelect({ value: state.next, valueChange: nextStepChange })}
    </>
  );
});
